<template>
  <div class="bg">
      <div class="select">
          <div class="header">
              <div class="title">选择监测场所</div>
              <div class="close" @click="close">取消</div>
          </div>
          <ul>
              <li v-for="item in selsectData" :key="item.sn" @click="selectClick(item)">{{item.equipment}}</li>
          </ul>
      </div>
  </div>
</template>

<script>
export default {
  name: "vuePickers",
  props:{
      selsectData:{
          type: Array
      },

  },
  data() {
    return {};
  },
  computed: {},
  methods: {
    selectClick(sn) {
        this.$emit("select",sn)
    },
    close() {
       this.$emit("close") 
    }
  }
};
</script>

<style lang="less" scoped>
.bg {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.7);
    top: 0;
    left: 0;
    z-index: 99;
    .select {
        position: absolute;
        height: 200px;
        width: 100%;
        background-color: #fff;
        bottom: 0;
        left: 0;
        border-radius: 8px 8px 0 0;
    }
    .header {
        height: 50px;
        line-height: 50px;
        border-bottom: 1px solid #f2f2f2;
        .title {
            width: 100%;
            text-align: center;
        }
        .close {
            position: absolute;
            width: 50px;
            height: 50px;
            top:0;
            right: 0;
            line-height: 50px;
        }
    }
    ul {
        width: 100%;
        height: 150px;
        overflow-y: scroll;
        -webkit-overflow-scrolling : touch;
        li {
            height: 50px;
            line-height: 50px;
            text-align: center;
            border-bottom: 1px solid #f2f2f2;

        }
    }
}
</style>
